
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9avSx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "closeDialog", () => $e28764ed19a11860$export$34bf1befb2fab61a);
$parcel$export(module.exports, "getOpenDialog", () => $e28764ed19a11860$export$cf40ddca756b7741);
$parcel$export(module.exports, "useModalDialogCleanupEffect", () => $e28764ed19a11860$export$586cda8757903229);
$parcel$export(module.exports, "useRegisterModalDialogAnalytics", () => $e28764ed19a11860$export$fc10f874e8bd1adc);
$parcel$export(module.exports, "useInlineDialogZIndexOverrideLayoutEffect", () => $e28764ed19a11860$export$84648db9790b0ee);
$parcel$export(module.exports, "default", () => $e28764ed19a11860$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3NMrl = parcelRequire("3NMrl");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jcw0u = parcelRequire("jcw0u");

var $jDKvL = parcelRequire("jDKvL");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $9a0pp = parcelRequire("9a0pp");

var $bpQ8L = parcelRequire("bpQ8L");

var $3SLjO = parcelRequire("3SLjO");

var $6cgrB = parcelRequire("6cgrB");

var $7trNp = parcelRequire("7trNp");

var $gyc0O = parcelRequire("gyc0O");

var $7TLyd = parcelRequire("7TLyd");
const $e28764ed19a11860$export$34bf1befb2fab61a = ()=>window.connectHost?.dialog?.close();
const $e28764ed19a11860$export$cf40ddca756b7741 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const topEl = window.AJS?.LayerManager?.global?.getTopLayer();
    if (topEl == null) return null;
    return topEl.find('iframe')?.[0];
};
const $e28764ed19a11860$export$586cda8757903229 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useEffect)(()=>()=>{
            try {
                const dialogBeforeClose = $e28764ed19a11860$export$cf40ddca756b7741();
                $e28764ed19a11860$export$34bf1befb2fab61a();
                const dialogNow = $e28764ed19a11860$export$cf40ddca756b7741();
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), dialogBeforeClose && dialogNow ? 'iframe not closed' : 'iframe closed', 'apps', {
                    // Match the unique key part separated by a final __ delimination
                    uniqueKey: dialogBeforeClose?.id.match(/.*(?=__)/)?.[0] ?? dialogBeforeClose?.id,
                    uniqueOpenKey: dialogNow?.id.match(/.*(?=__)/)?.[0] ?? dialogNow?.id
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'issue-navigator-action-pluggable-items.ui.useModalDialogCleanupEffect',
                        packageName: 'jiraIssueNavigatorActionPluggableItems',
                        teamName: 'empanada'
                    }
                });
            }
        }, [
        createAnalyticsEvent
    ]);
};
const $e28764ed19a11860$export$fc10f874e8bd1adc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const iFrameEstablishedCallback = (0, $5uXOq.useCallback)((payload)=>{
        if (payload.extension.options.moduleType === 'dialogs') (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'iframe established', 'apps', (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(payload.extension.options, [
            'addon_key',
            'isDialog',
            'dialogId',
            'isFullPage',
            'uniqueKey',
            'origin'
        ]));
    }, [
        createAnalyticsEvent
    ]);
    const timeoutIdRef = (0, $5uXOq.useRef)();
    const registerListeners = (0, $5uXOq.useCallback)(()=>{
        // Connect doesn't seem to have a way to notify when it has been registered, so we have to resort to polling
        timeoutIdRef.current = setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (!window.connectHost) registerListeners();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.connectHost.onIframeEstablished(iFrameEstablishedCallback);
        }, 1000);
    }, [
        iFrameEstablishedCallback
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>()=>{
            clearTimeout(timeoutIdRef.current);
            // @ts-expect-error - TS2339 - Unsafe use of Connect's internal API
            if (iFrameEstablishedCallback._wrapper != null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.connectHost?.offIframeEstablished(iFrameEstablishedCallback);
            timeoutIdRef.current = undefined;
        }, [
        iFrameEstablishedCallback,
        registerListeners
    ]);
    return ()=>{
        if (timeoutIdRef.current === undefined) registerListeners();
    };
};
const $e28764ed19a11860$export$84648db9790b0ee = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { current: styleNode } = (0, $5uXOq.useRef)(document.createElement('style'));
    (0, $5uXOq.useLayoutEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(styleNode);
        styleNode.setAttribute('data-nin-pluggable-items', 'css');
        styleNode.sheet?.insertRule('div.aui-inline-dialog[id^="inline-dialog-webitem-"]{z-index:401}', 0);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.head?.removeChild(styleNode);
        };
    }, [
        styleNode
    ]);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e28764ed19a11860$var$PluggableItems = ()=>{
    const [fetchData, { loading: loading, error: error, data: data }] = (0, $9a0pp.usePluggableItemsQuery)();
    const [isAnyAppLoading] = (0, $jDKvL.useIsAnyAppLoading)();
    const [, { closeApps: closeApps }] = (0, $jDKvL.useForgeApps)();
    const totalCount = data?.length ?? 0;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const allIds = (0, $5uXOq.useMemo)(()=>data?.map((item)=>item?.id) ?? [], [
        data
    ]);
    const registerModalDialogAnalytics = $e28764ed19a11860$export$fc10f874e8bd1adc();
    $e28764ed19a11860$export$586cda8757903229();
    $e28764ed19a11860$export$84648db9790b0ee();
    // Close the dropdown when all Forge apps are loaded.
    // In practice it will be a single app at a time, but we can't rely on that.
    (0, $5uXOq.useEffect)(()=>{
        if (!isAnyAppLoading) setIsOpen(false);
    }, [
        isAnyAppLoading
    ]);
    // Close all Forge apps when the data is re-fetched
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            await closeApps();
        })();
    }, [
        data,
        closeApps
    ]);
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        // Ignore events originating from a matching iframe or an element inside an iframe
        const eventTarget = attrs.event?.target;
        if (eventTarget && eventTarget instanceof HTMLElement && (0, $7TLyd.isInOrIsIFrame)(eventTarget, allIds)) return;
        if (attrs.isOpen) {
            if (!loading) fetchData(error);
            // Only setup analytics when the dialog is opened
            registerModalDialogAnalytics();
        }
        setIsOpen(attrs.isOpen);
    }, [
        allIds,
        error,
        fetchData,
        loading,
        registerModalDialogAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isLoading: loading,
        testId: "issue-navigator-action-pluggable-items.ui.filter-button",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7trNp.PluggableItemsFilterButton), {
                ...props,
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        spacing: "compact",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e28764ed19a11860$var$containerStyles
    }, !error && totalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, data?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3SLjO.DropdownItemWithApps), {
            key: item.id,
            item: item,
            totalCount: totalCount
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e28764ed19a11860$var$maxWidthContainerStyles,
        role: "menuitem"
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        pageAction: "apps",
        onRetry: ()=>fetchData(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "errorDropdown",
        actionSubjectId: "issueNavigatorActionsPluggableItems"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6cgrB.Empty), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gyc0O.IssueNavigatorActionRuntimeContainer), null));
};
const $e28764ed19a11860$var$PlagguebleItemsWithForge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDKvL.ForgeAppsContainer), {
        scope: "issue-navigator-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e28764ed19a11860$var$PluggableItems, null));
var $e28764ed19a11860$export$2e2bcd8739ae039 = $e28764ed19a11860$var$PlagguebleItemsWithForge;
const $e28764ed19a11860$var$containerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $bpQ8L.ACTIONS_MIN_WIDTH)}px`
});
const $e28764ed19a11860$var$maxWidthContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $bpQ8L.CONTAINER_MIN_WIDTH)}px`
});

});
parcelRegister("jDKvL", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsContainer", () => $b68f39b65da4eb25$export$9d26afcb39445b8e);
$parcel$export(module.exports, "useForgeApps", () => $b68f39b65da4eb25$export$a48819842c5a2f15);
$parcel$export(module.exports, "useIsAppLoading", () => $b68f39b65da4eb25$export$24db0add8de543af);
$parcel$export(module.exports, "useIsAnyAppLoading", () => $b68f39b65da4eb25$export$f65d61db50b49f3);

var $7Jxgt = parcelRequire("7Jxgt");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b68f39b65da4eb25$export$9d26afcb39445b8e = (0, $gg7kZ.createContainer)();
const $b68f39b65da4eb25$var$actions = {
    openApp: (appId, extension, action, extensionData = {})=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: [
                    ...openedApps.filter((app)=>app.id !== appId || app.action !== action),
                    {
                        id: appId,
                        extension: extension,
                        extensionData: extensionData,
                        action: action,
                        uuid: (0, $7Jxgt.v4)(),
                        isLoading: true
                    }
                ]
            });
        },
    setAppLoaded: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.map((app)=>app.id === appId && app.action === action && app.isLoading ? {
                        ...app,
                        isLoading: false
                    } : app)
            });
        },
    closeApps: ()=>({ setState: setState })=>{
            setState({
                openedApps: []
            });
        },
    closeApp: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.filter((app)=>app.id !== appId || app.action !== action)
            });
        }
};
const $b68f39b65da4eb25$var$Store = (0, $iXqE5.createStore)({
    containedBy: $b68f39b65da4eb25$export$9d26afcb39445b8e,
    initialState: {
        openedApps: []
    },
    actions: $b68f39b65da4eb25$var$actions
});
const $b68f39b65da4eb25$export$a48819842c5a2f15 = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store);
const $b68f39b65da4eb25$var$isAppLoading = (state, { appId: appId, action: action })=>{
    return state.openedApps.some((app)=>app.id === appId && app.action === action && app.isLoading);
};
const $b68f39b65da4eb25$export$24db0add8de543af = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store, {
    selector: $b68f39b65da4eb25$var$isAppLoading
});
const $b68f39b65da4eb25$var$isAnyAppLoading = (state)=>state.openedApps.some((app)=>app.isLoading);
const $b68f39b65da4eb25$export$f65d61db50b49f3 = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store, {
    selector: $b68f39b65da4eb25$var$isAnyAppLoading
});

});

parcelRegister("9a0pp", function(module, exports) {

$parcel$export(module.exports, "usePluggableItemsQuery", () => $179e14d9fca7acd4$export$77eee11e2025ce36);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $eusud = parcelRequire("eusud");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $9Nvh7 = parcelRequire("9Nvh7");

var $gwtSG = parcelRequire("gwtSG");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $DVljb = parcelRequire("DVljb");

var $2wz9x = parcelRequire("2wz9x");
const $179e14d9fca7acd4$export$77eee11e2025ce36 = ()=>{
    const [pluggableItems, setPluggableItems] = (0, $5uXOq.useState)({
        ...$179e14d9fca7acd4$export$774a4ee00eaf0f75
    });
    const { jql: jql, filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const locale = (0, $DVljb.useLocale)();
    const key = !jql && (0, $9Nvh7.isFilterId)(filterId) ? filterId : jql;
    const currentKeyRef = (0, $5uXOq.useRef)(key);
    const { current: intlCollator } = (0, $5uXOq.useRef)(new Intl.Collator((0, $lzeFL.standardizeLocale)(locale)));
    const lastKeyRef = (0, $5uXOq.useRef)(null);
    const fetchPluggableItems = (0, $5uXOq.useCallback)((forceRefetch = false)=>{
        if (forceRefetch || lastKeyRef.current == null || lastKeyRef.current !== currentKeyRef.current) {
            setPluggableItems({
                data: undefined,
                loading: true,
                error: false
            });
            Promise.all([
                (0, $iVaKa.fetchModules)({
                    cloudId: cloudId,
                    isAnonymous: isAnonymous,
                    context: {},
                    types: [
                        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE)
                    ],
                    includeHidden: false,
                    source: 'issue-navigator'
                }),
                (0, $eusud.performPostRequest)('/rest/gira/1/?operation=IssueNavigatorPluggableItemsQuery', {
                    body: JSON.stringify({
                        query: (0, $2wz9x.ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY),
                        variables: {
                            first: 100
                        }
                    })
                })
            ]).then(([forgeModules, connectResponse])=>{
                if (connectResponse.errors) setPluggableItems({
                    data: null,
                    loading: false,
                    error: true
                });
                else setPluggableItems({
                    data: $179e14d9fca7acd4$var$transform(forgeModules[0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE], connectResponse.data?.jiraWebSection?.webItems?.nodes, intlCollator.compare),
                    loading: false,
                    error: false
                });
            }).catch(()=>{
                setPluggableItems({
                    data: null,
                    loading: false,
                    error: true
                });
            });
            lastKeyRef.current = currentKeyRef.current;
        }
    }, [
        cloudId,
        isAnonymous,
        intlCollator.compare
    ]);
    // Sync this to avoid recreating the callback and mitigating rerender
    currentKeyRef.current = key;
    return (0, $5uXOq.useMemo)(()=>[
            fetchPluggableItems,
            pluggableItems
        ], [
        pluggableItems,
        fetchPluggableItems
    ]);
};
const $179e14d9fca7acd4$export$774a4ee00eaf0f75 = {
    data: undefined,
    loading: false,
    error: false
};
function $179e14d9fca7acd4$var$transform(forgeModules, connectModules, comparator) {
    return [
        ...forgeModules.map((module)=>{
            return {
                type: 'forge',
                id: module.id,
                title: module.properties.title,
                iconUrl: module.properties.icon ?? null,
                tooltip: module.properties.tooltip ?? null,
                metadata: module
            };
        }),
        ...connectModules.filter((item)=>item.label != null).map((module)=>({
                type: 'connect',
                id: module.id,
                title: module.label || '',
                iconUrl: module.iconUrl,
                tooltip: module.tooltip,
                metadata: module
            }))
    ].sort((a, b)=>comparator(a.title, b.title));
}

});
parcelRegister("2wz9x", function(module, exports) {

$parcel$export(module.exports, "ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY", () => $6b40e93ca17b03a3$export$832447adf89352b6);

var $92ECu = parcelRequire("92ECu");
const $6b40e93ca17b03a3$export$832447adf89352b6 = (0, $92ECu.gqlTagGira)`
  query IssueNavigatorPluggableItemsQuery($first: Int!) {
    jiraWebSection(input: { location: JIRA_NAVIGATOR }) {
      webItems(first: $first) {
        pageInfo {
          hasNextPage
        }
        totalCount
        nodes {
          id
          label
          tooltip
          iconUrl
          target {
            type
            addonKey
            moduleKey
            ...on JiraWebItemTargetDialogModule {
              targetKey
            }
          }
        }
      }
    }
  }
`;

});
parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});



parcelRegister("bpQ8L", function(module, exports) {

$parcel$export(module.exports, "ACTIONS_MIN_WIDTH", () => $6b398bcc00d2d7e4$export$6136614e7d9538ed);
$parcel$export(module.exports, "CONTAINER_MIN_WIDTH", () => $6b398bcc00d2d7e4$export$23f5cd335b4ac583);

var $gwIPs = parcelRequire("gwIPs");
const $6b398bcc00d2d7e4$export$6136614e7d9538ed = (0, $gwIPs.gridSize) * 25; // 200
const $6b398bcc00d2d7e4$export$23f5cd335b4ac583 = (0, $gwIPs.gridSize) * 30; // 240

});

parcelRegister("3SLjO", function(module, exports) {

$parcel$export(module.exports, "DropdownItemWithApps", () => $c4e0ed4062fb033b$export$6d69d82af462f986);

var $5uXOq = parcelRequire("5uXOq");

var $eiURs = parcelRequire("eiURs");

var $96nUw = parcelRequire("96nUw");
const $c4e0ed4062fb033b$export$6d69d82af462f986 = (props)=>{
    if ($c4e0ed4062fb033b$var$isForgeProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96nUw.ForgeDropdownItemWithErrorBoundary), props);
    if ($c4e0ed4062fb033b$var$isConnectProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiURs.ConnectDropdownItem), props);
    return null;
};
function $c4e0ed4062fb033b$var$isForgeProps(props) {
    return props.item.type === 'forge';
}
function $c4e0ed4062fb033b$var$isConnectProps(props) {
    return props.item.type === 'connect';
}

});
parcelRegister("eiURs", function(module, exports) {

$parcel$export(module.exports, "ConnectDropdownItem", () => $ded43791885d4ca3$export$e253d0820bea0fd6);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7TLyd = parcelRequire("7TLyd");

var $g1ROh = parcelRequire("g1ROh");
const $ded43791885d4ca3$export$e253d0820bea0fd6 = ({ item: item, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ded43791885d4ca3$export$c0117b1abc6c64e3, {
        testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.connect-dropdown-item.drop-down-item",
        key: item.id,
        id: item.id ?? undefined,
        title: typeof item.tooltip === 'string' ? item.tooltip : undefined,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1ROh.AppIcon), {
            iconUrl: item.iconUrl
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: item.metadata.target && (0, $7TLyd.buildStyleClass)(item.metadata.target) || '',
        analyticsAppCount: totalCount,
        analyticsAppName: item.title ?? '',
        analyticsAppType: (0, $7TLyd.translateAppTypeToAnalyticsType)(item.metadata.target?.type)
    }, item.title);
function $ded43791885d4ca3$export$c0117b1abc6c64e3({ analyticsAppName: analyticsAppName, analyticsAppCount: analyticsAppCount, analyticsAppType: analyticsAppType, testId: testId, ...props }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireDropdownClickUIAnalytics = (0, $5uXOq.useCallback)((event)=>{
        if ('key' in event && event.key != null && event.key !== 'Enter' && event.key !== ' ') return;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'apps', {
            uniqueKey: props.id,
            source: 'key' in event ? 'keypress' : 'click',
            appCount: analyticsAppCount,
            appName: analyticsAppName,
            appType: analyticsAppType
        });
    }, [
        analyticsAppCount,
        analyticsAppName,
        analyticsAppType,
        createAnalyticsEvent,
        props.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        ...props,
        onClick: fireDropdownClickUIAnalytics,
        testId: testId
    });
}

});
parcelRegister("7TLyd", function(module, exports) {

$parcel$export(module.exports, "buildStyleClass", () => $b526404e79e0547b$export$f8c1d825aaa31bf2);
$parcel$export(module.exports, "isInOrIsIFrame", () => $b526404e79e0547b$export$5f8a28ced7cd3069);
$parcel$export(module.exports, "translateAppTypeToAnalyticsType", () => $b526404e79e0547b$export$7beec86e5c4555f8);
const $b526404e79e0547b$export$f8c1d825aaa31bf2 = (target)=>{
    const classes = [];
    switch(target.type){
        case 'DIALOG':
            classes.push('ap-dialog');
            break;
        case 'DIALOG_MODULE':
            classes.push('ap-dialog');
            if ('targetKey' in target && target.targetKey != null) classes.push(`ap-target-key-${target.targetKey}`);
            break;
        case 'INLINE_DIALOG':
            classes.push('ap-inline-dialog');
            break;
        default:
            break;
    }
    if (target.addonKey != null) classes.push(`ap-plugin-key-${target.addonKey}`);
    if (target.moduleKey != null) classes.push(`ap-module-key-${target.moduleKey}`);
    return classes.join(' ');
};
const $b526404e79e0547b$export$5f8a28ced7cd3069 = (element, idLooseMatchList)=>{
    const isIFrameWithMatchingId = element.nodeName === 'IFRAME' && !!idLooseMatchList.find((id)=>element.id.match(id));
    const isDifferentOwnerDocument = element.ownerDocument !== document;
    return isIFrameWithMatchingId || isDifferentOwnerDocument;
};
const $b526404e79e0547b$export$7beec86e5c4555f8 = (type)=>{
    switch(type){
        case 'DIALOG':
            return 'dialog';
        case 'DIALOG_MODULE':
            return 'dialog_module';
        case 'INLINE_DIALOG':
            return 'inline_dialog';
        default:
            return 'unknown';
    }
};

});

parcelRegister("g1ROh", function(module, exports) {

$parcel$export(module.exports, "AppIcon", () => $bfe22e283053ab47$export$5153830bdfb71453);

var $5uXOq = parcelRequire("5uXOq");

var $8vDvO = parcelRequire("8vDvO");

var $k4j3t = parcelRequire("k4j3t");
const $bfe22e283053ab47$export$5153830bdfb71453 = ({ iconUrl: iconUrl })=>{
    return iconUrl != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4j3t.IconCustom), {
        shouldChangeFillColor: false,
        url: iconUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: "",
        testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.app-icon.default-icon"
    });
};

});


parcelRegister("96nUw", function(module, exports) {

$parcel$export(module.exports, "ForgeDropdownItemWithErrorBoundary", () => $8afcfc181186becc$export$f593ef049d8ab980);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $hWZau = parcelRequire("hWZau");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $b71gk = parcelRequire("b71gk");

var $jDKvL = parcelRequire("jDKvL");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");

var $6hNNP = parcelRequire("6hNNP");

var $aKvxY = parcelRequire("aKvxY");

var $h0JHu = parcelRequire("h0JHu");

var $5NwJk = parcelRequire("5NwJk");

var $gwtSG = parcelRequire("gwtSG");

var $bpQ8L = parcelRequire("bpQ8L");

var $g1ROh = parcelRequire("g1ROh");
const $8afcfc181186becc$export$f593ef049d8ab980 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-dropdown-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$export$df33c67d25a78185, props));
};
function $8afcfc181186becc$export$df33c67d25a78185({ item: item, totalCount: totalCount }) {
    const jql = (0, $gwtSG.useResolvedJql)();
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const issueKey = (0, $5NwJk.useSelectedIssueKey)();
    const issueNavigatorData = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            issueKeys: issueKey ? [
                issueKey
            ] : []
        }), [
        jql,
        filterId,
        issueKey
    ]);
    const title = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
            extensionName: item.title,
            extensionEnvType: item.metadata.environmentType,
            extensionEnvKey: item.metadata.environmentKey,
            autoTruncate: true
        });
    }, [
        item.metadata.environmentKey,
        item.metadata.environmentType,
        item.title
    ]);
    return item.metadata.properties.actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$var$ForgeDropdownItemWithActions, {
        item: item,
        totalCount: totalCount,
        issueNavigatorData: issueNavigatorData,
        title: title
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$var$ForgeDropdownItemSimple, {
        item: item,
        totalCount: totalCount,
        issueNavigatorData: issueNavigatorData,
        title: title
    });
}
function $8afcfc181186becc$var$ForgeDropdownItemSimple({ item: item, totalCount: totalCount, issueNavigatorData: issueNavigatorData, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$export$c0117b1abc6c64e3, {
        key: item.id,
        itemType: "forge-app",
        testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.forge-dropdown-item.action-drop-down-item",
        item: item,
        totalCount: totalCount,
        issueNavigatorData: issueNavigatorData,
        tooltip: typeof item.tooltip === 'string' ? item.tooltip : undefined,
        title: title
    }));
}
function $8afcfc181186becc$var$ForgeDropdownItemWithActions({ item: item, totalCount: totalCount, issueNavigatorData: issueNavigatorData, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        key: item.id,
        placement: "right-start",
        shouldFlip: true,
        spacing: "compact",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                ...triggerProps,
                ref: triggerRef,
                title: typeof item.tooltip === 'string' ? item.tooltip : undefined,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1ROh.AppIcon), {
                    iconUrl: item.iconUrl
                }),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #626F86)",
                    label: ""
                })
            }, title),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8afcfc181186becc$var$actionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, (item.metadata.properties.actions ?? []).map((action)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$export$c0117b1abc6c64e3, {
            key: `${item.id}${action.key}`,
            itemType: "forge-action",
            testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.forge-dropdown-item.action-drop-down-item",
            item: item,
            action: action,
            totalCount: totalCount,
            issueNavigatorData: issueNavigatorData,
            tooltip: typeof action.tooltip === 'string' ? action.tooltip : undefined,
            title: action.title
        });
    }))));
}
function $8afcfc181186becc$export$c0117b1abc6c64e3(props) {
    const { totalCount: totalCount, itemType: itemType, item: item, action: action } = props;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(item.metadata),
            analyticsAppName: item.title,
            analyticsActionName: action?.title,
            analyticsAppCount: totalCount,
            analyticsAppType: itemType,
            source: 'issue-navigator'
        }), [
        action?.title,
        item.metadata,
        item.title,
        itemType,
        totalCount
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        (0, $6hNNP.fireUiTriggerClickedEvent)(item.id, 'issue-navigator', analyticsAttributes);
    }, [
        analyticsAttributes,
        item.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKvxY.TriggerAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$var$DropdownItemInner, {
        ...props,
        onClick: handleOnClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: analyticsAttributes
    }));
}
function $8afcfc181186becc$var$DropdownItemInner({ totalCount: totalCount, itemType: itemType, testId: testId, item: item, title: title, action: action, issueNavigatorData: issueNavigatorData, onClick: onClick, tooltip: tooltip, ...props }) {
    const [isAppLoading] = (0, $jDKvL.useIsAppLoading)({
        appId: item.id,
        action: action?.key
    });
    const [, { openApp: openApp }] = (0, $jDKvL.useForgeApps)();
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        onClick();
        openApp(item.id, item.metadata, action?.key, {
            ...issueNavigatorData,
            action: action?.key
        });
    }, [
        action?.key,
        issueNavigatorData,
        item.id,
        item.metadata,
        onClick,
        openApp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        ...props,
        title: tooltip,
        onClick: handleOnClick,
        testId: testId,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8afcfc181186becc$var$LoadingIndicator, {
            isAppLoading: isAppLoading
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1ROh.AppIcon), {
            iconUrl: item.iconUrl
        })
    }, title);
}
function $8afcfc181186becc$var$LoadingIndicator({ isAppLoading: isAppLoading }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8afcfc181186becc$var$indicatorStyle
    }, isAppLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }));
}
const $8afcfc181186becc$var$indicatorStyle = (0, $8CUq3.xcss)({
    width: "var(--ds-space-150, 12px)"
});
const $8afcfc181186becc$var$actionsContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $bpQ8L.ACTIONS_MIN_WIDTH)}px`
});

});
parcelRegister("6hNNP", function(module, exports) {

$parcel$export(module.exports, "fireUiTriggerClickedEvent", () => $a848195cd9b17c19$export$cc0cc6563e35ae9);

var $k2DRb = parcelRequire("k2DRb");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $4R6GH = parcelRequire("4R6GH");
const $a848195cd9b17c19$var$triggerEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
});
const $a848195cd9b17c19$export$cc0cc6563e35ae9 = (extensionId, source, attributes)=>{
    (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
        }) : $a848195cd9b17c19$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};

});

parcelRegister("aKvxY", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $a202a2d6f9718fec$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $a202a2d6f9718fec$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $a202a2d6f9718fec$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        ...props
    });
const $a202a2d6f9718fec$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});



parcelRegister("6cgrB", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $13b05d9f6dfc2c61$export$1f74963c34e8bfec);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $80P9l = parcelRequire("80P9l");

var $koVbs = parcelRequire("koVbs");

var $9tV8T = parcelRequire("9tV8T");
const $13b05d9f6dfc2c61$export$1f74963c34e8bfec = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13b05d9f6dfc2c61$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $13b05d9f6dfc2c61$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80P9l.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13b05d9f6dfc2c61$var$P, null, formatMessage((0, $9tV8T.default).empty)));
};
const $13b05d9f6dfc2c61$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    height: '72px',
    width: '72px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13b05d9f6dfc2c61$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _19pku2gc _2hwxutpp _otyru2gc _18u0utpp _vwz47vkz",
            __cmplp.className
        ])
    });
});
const $13b05d9f6dfc2c61$var$P = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5724jg8 _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("80P9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6043373c6b544137$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cXdza")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cXdza")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $dCLgq = parcelRequire("dCLgq");

var $cXdza = parcelRequire("cXdza");
const $6043373c6b544137$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cXdza)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cXdza))
});
var $6043373c6b544137$export$2e2bcd8739ae039 = $6043373c6b544137$var$Illustration;
// for advanced use only
const $6043373c6b544137$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("cXdza", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});


parcelRegister("9tV8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b15909eb23ae4bdb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b15909eb23ae4bdb$var$messages = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "issue-navigator-action-pluggable-items.empty.empty",
        "defaultMessage": "There are no apps installed for the Issue Navigator"
    }
});
var $b15909eb23ae4bdb$export$2e2bcd8739ae039 = $b15909eb23ae4bdb$var$messages;

});


parcelRegister("gyc0O", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorActionRuntimeContainer", () => $21e183566c310b1e$export$7b26d9e8e90b5c69);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $bfAsP = parcelRequire("bfAsP");

var $2RhPB = parcelRequire("2RhPB");

var $aKvxY = parcelRequire("aKvxY");

var $5aO0g = parcelRequire("5aO0g");
const $21e183566c310b1e$export$cfffe81d508bcda3 = ({ app: app, setLoaded: setLoaded, localId: localId, handleError: baseHandleError, closeApp: closeApp })=>{
    // TO DO: add handling for app timeout
    // https://ecosystem-platform.atlassian.net/browse/ARKEN-1786
    // Force render the default error message (instead of the content from the error).
    // By default baseHandleError accepts error message as a parameter
    const handleError = (0, $5uXOq.useCallback)(()=>{
        baseHandleError && baseHandleError();
    }, [
        baseHandleError
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(app.extension),
            source: 'issue-navigator'
        }), [
        app.extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKvxY.ViewAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aO0g.AsyncIssueNavigatorAction), {
        localId: localId,
        extensionData: app.extensionData,
        extension: app.extension,
        analyticsAttributes: analyticsAttributes,
        onLoad: setLoaded,
        onInitialRender: setLoaded,
        onError: handleError,
        onClose: closeApp
    }));
};
const $21e183566c310b1e$export$7b26d9e8e90b5c69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-issue-navigator-action-runtime-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfAsP.ForgeAppsRuntimeContainer), {
        forgeAppRenderer: $21e183566c310b1e$export$cfffe81d508bcda3
    }));

});
parcelRegister("bfAsP", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsRuntimeContainer", () => $4f172c8b740168bb$export$db56fac1456ccba8);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $4siKa = parcelRequire("4siKa");

var $koVbs = parcelRequire("koVbs");

var $jDKvL = parcelRequire("jDKvL");

var $xd3DV = parcelRequire("xd3DV");
const $4f172c8b740168bb$var$toTargetForgeApp = (app)=>{
    return {
        id: app.id,
        extension: app.extension,
        extensionData: app.action ? {
            ...app.extensionData,
            action: app.action
        } : app.extensionData
    };
};
const $4f172c8b740168bb$var$BaseForgeAppRenderer = ({ app: app, setAppLoaded: setAppLoaded, setAppClose: setAppClose, renderer: ForgeAppRendererComponent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const localId = app.extensionData.action ? `${app.id},action:${app.extensionData.action}` : app.id;
    const setLoaded = (0, $5uXOq.useCallback)(()=>{
        app.isLoading && setAppLoaded(app.id, app.action);
    }, [
        app.id,
        app.action,
        app.isLoading,
        setAppLoaded
    ]);
    const closeApp = (0, $5uXOq.useCallback)(()=>{
        setAppClose(app.id, app.action);
    }, [
        app.id,
        app.action,
        setAppClose
    ]);
    const targetApp = (0, $5uXOq.useMemo)(()=>$4f172c8b740168bb$var$toTargetForgeApp(app), [
        app
    ]);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const handleError = (0, $5uXOq.useCallback)((msg)=>{
        showFlag({
            key: localId,
            type: 'error',
            title: formatMessage((0, $xd3DV.messages).appErrorTitle),
            description: msg ?? formatMessage((0, $xd3DV.messages).appErrorDescription),
            messageId: 'forge-action-apps-controller.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        localId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeAppRendererComponent, {
        localId: localId,
        app: targetApp,
        setLoaded: setLoaded,
        closeApp: closeApp,
        isLoading: app.isLoading,
        handleError: handleError
    });
};
const $4f172c8b740168bb$export$db56fac1456ccba8 = ({ forgeAppRenderer: forgeAppRenderer })=>{
    const [{ openedApps: openedApps }, { setAppLoaded: setAppLoaded, closeApps: closeApps, closeApp: closeApp }] = (0, $jDKvL.useForgeApps)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            closeApps();
        };
    }, [
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4siKa.InvisibleDiv), null, openedApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f172c8b740168bb$var$BaseForgeAppRenderer, {
            key: app.uuid,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            app: app,
            setAppLoaded: setAppLoaded,
            setAppClose: closeApp,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            renderer: forgeAppRenderer
        })));
};

});
parcelRegister("4siKa", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $cfdc7368b5d9a379$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cfdc7368b5d9a379$export$22ef238a7bbeac70 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $cfdc7368b5d9a379$export$1442582cffa6fcb7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("xd3DV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f35d1e21793a4908$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f35d1e21793a4908$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    appErrorTitle: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-title",
        "defaultMessage": "App Error"
    },
    appErrorDescription: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-description",
        "defaultMessage": "An error occurred while loading the app"
    }
});

});


parcelRegister("5aO0g", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueNavigatorAction", () => $3423268f67965727$export$972ed080d6cd6f83);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $hYRTO = parcelRequire("hYRTO");

var $eqQcV = parcelRequire("eqQcV");

var $4R6GH = parcelRequire("4R6GH");
const $3423268f67965727$export$c83cb1d538aeaee0 = (props)=>{
    const { extension: extension, extensionData: extensionData, ...restProps } = props;
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>({
            ...extensionData,
            type: (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            module: (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
            extensionData: extensionDataValue,
            extension: extension,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extension,
        extensionDataValue
    ]);
    const bridge = (0, $5uXOq.useMemo)(()=>({
            close: props.onClose
        }), [
        props.onClose
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension) || (0, $3mOWa.isCustomUIExtension)(extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "issue-navigator-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqQcV.LazyIssueNavigatorForgeExtension), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        hasModalConsentPrompt: true,
        ...(0, $4R6GH.fg)('do_not_pass_hide_iframe_prop_to_the_renderer') ? {} : {
            isIframeHidden: true
        }
    }));
    return null;
};
const $3423268f67965727$export$972ed080d6cd6f83 = $3423268f67965727$export$c83cb1d538aeaee0;

});
parcelRegister("eqQcV", function(module, exports) {

$parcel$export(module.exports, "LazyIssueNavigatorForgeExtension", () => $0888911c1fa86e74$export$6a4f9722384892ff);

var $1rTGO = parcelRequire("1rTGO");

var $kxZPA = parcelRequire("kxZPA");

const $0888911c1fa86e74$var$getModule = ()=>(parcelRequire("6UpjM"));
const $0888911c1fa86e74$export$6a4f9722384892ff = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$0888911c1fa86e74$var$getModule().then((module)=>module.IssueNavigatorForgeExtension), {
    ssr: false
}));

});
parcelRegister("6UpjM", function(module, exports) {

let $507b9ca63860f874$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $507b9ca63860f874$var$load("kWrFZ"),
    $507b9ca63860f874$var$load("cM9em"),
    $507b9ca63860f874$var$load("fr9NE"),
    $507b9ca63860f874$var$load("hPzOn"),
    $507b9ca63860f874$var$load("h2MrD"),
    $507b9ca63860f874$var$load("bYT2S"),
    $507b9ca63860f874$var$load("gTVOQ")
]).then(()=>parcelRequire('bv4la'));

});






//# sourceMappingURL=async-pluggable-items.b3399bb1.js.map
